import src from "IMAGE";
export default { src, width: 205, height: 204, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAQklEQVR42qWPOwoAIAxDO/pJKe39D6sZFAelg4EHIYSWiBwys0bkpbSgqpVcQwDF3UHod3kGnfB0RIDQrzx/8b1iABB3BfnmyTbTAAAAAElFTkSuQmCC"};
